import React from "react";
import styles from "./footer.module.css";
import { Link } from "react-router-dom";
import CookiesConsent from "../cookies_consent/cookies_consent";
import { COMPANY_SELLER, PHONE_NUMBERS, EMAILS } from "../../utils/constants";

function Footer() {

  return (
    <footer className={`${styles.footer}`}>
      <CookiesConsent />
      <div className={styles.container}>
        <div className={`${styles.column}`}>
          <h3 className={styles.column_title}>Контакты</h3>

          <ul className={styles.list}>
            {
              PHONE_NUMBERS.map((phone, index) => {
                return (
                  <li key={index}>
                    {phone.name ?
                      <Link to={phone.link} className={`${styles.link} ${styles.link_contacts}`}>
                        <span style={{ 'fontWeight': 500 }}>{phone.name}</span>: {phone.number}
                      </Link>
                      :
                      <Link to={phone.link} className={`${styles.link} ${styles.link_contacts}`}>
                        {phone.number}
                      </Link>
                    }
                  </li>
                )
              })
            }
          </ul>

          <ul className={styles.list}>
            {
              EMAILS.map((email, index) => {
                return (
                  <li key={index}>
                    {email.name ?
                      <Link to={`mailto:${email.email}`} className={`${styles.link} ${styles.link_contacts}`}>
                        <span style={{ 'fontWeight': 500 }}>{email.name}:</span> {email.email}
                      </Link> :
                      <Link to={`mailto:${email.email}`} className={`${styles.link} ${styles.link_contacts}`}>
                        {email.email}
                      </Link>
                    }
                  </li>
                )
              })
            }
          </ul>
        </div>

        <div className={`${styles.column}`}>
          <h3 className={styles.column_title}>Правовая информация</h3>
          <ul className={styles.list}>
            <li>
              <Link to='/agreement' className={styles.link}>
                Пользовательское соглашение
              </Link>
            </li>
            <li>
              <Link to='/personal-data' className={styles.link}>
                Политика обработки персональных данных
              </Link>
            </li>
            <li>
              <Link to='/cookie' className={styles.link}>
                Политика использования файлов Cookie
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <p className={styles.under_text}>
        {`${COMPANY_SELLER.name}, ИНН ${COMPANY_SELLER.inn}`}
      </p>
    </footer>
  );
}

export default Footer;
